import { Link } from "react-router-dom";

function Page() {
  return (
    <>
      <div className="col-md-9">
        <h1>EU:s förordning om gigabitinfrastruktur (EU) 2024/1309</h1>
        <div className="ingress">
          Den 12 november 2025 blev EU:s nya förordning om gigabitinfrastruktur
          (GIA) tillämplig. GIA syftar till att underlätta utbyggnaden av nät
          med mycket hög kapacitet och på sikt ersätta utbyggnadslagen.
        </div>
        <p>
          GIA är en utveckling av och ersätter utbyggnadsdirektivet som i
          Sverige införlivades genom utbyggnadslagen (2016:534). Förordningen
          avser att bemöta den ständigt växande efterfrågan på snabbare, mer
          tillförlitlig, och mer dataintensiv konnektivitet genom att underlätta
          utbyggnaden av nät med mycket hög kapacitet.
        </p>
        <p>
          <strong>Mer infrastruktur ingår</strong>
        </p>
        <p>
          För att uppnå detta ska förordningen ytterligare minska byråkratin,
          kostnaderna och den administrativa bördan i samband med utbyggnaden av
          nät med mycket hög kapacitet. Förenklade och digitaliserade
          tillståndsförfaranden med skärpta skyndsamhetskrav ska säkerställa att
          aktörer får tillgång till fysisk infrastruktur så som kanalisation,
          master och annan fysisk infrastruktur.
        </p>
        <p>
          Möjligheten att begära tillträde utvidgas till att omfatta även
          offentlig fysisk infrastruktur som inte ingår i ett nätverk, såsom
          byggnader och väg- och gatuutrustning (exempelvis ljusstolpar,
          trafikljus, vägskyltar, hållplatser och tunnelbanestationer).
          Operatörer kan därmed begära tillträde till en utökad mängd fysisk
          infrastruktur. Förordningen utvidgar även förutsättningarna för
          samordning av bygg- och anläggningsprojekt. <br />
        </p>
        <p>
          <strong>Central informationspunkt - en plats för information</strong>
        </p>
        <p>
          Den utvidgade möjligheten som förordningen ger operatörer som vill
          bygga ut nät med mycket hög kapacitet innebär att fler nätoperatörer
          och fler fysiska objekt omfattas. Därmed ska fler aktörer
          tillhandahålla information om en utökad mängd av fysiska objekt. Denna
          information ska operatörer som vill bygga ut nät med mycket hög
          kapacitet kunna begära via en central informationspunkt.
        </p>
        <p>
          Det ska även finnas möjlighet att ta del av annan relevant information
          via den centrala informationspunkten som hantering av tillstånd.
        </p>
        <p>
          <strong>PTS roll</strong>
        </p>
        <p>
          Gigabitutredningen har den 6 november 2025 lämnat över sitt betänkande
          till regeringen,&nbsp;
          <a href="https://www.regeringen.se/rattsliga-dokument/statens-offentliga-utredningar/2025/11/sou-2025110/">
            länk
          </a>
          . På regeringens uppdrag har Gigabitutredningen lämnat förslag på
          vilka anpassningar och kompletteringar som behöver göras i svensk
          lagstiftning med anledning av GIA.
        </p>
        <p>
          Nu förbereds en remiss av betänkandet. Det är inte ännu beslutat vilka
          myndigheter som ska ha ansvaret för GIA, men PTS föreslås bli ansvarig
          myndighet för viss tillsyn och tvistlösning samt den centrala
          informationspunkten. PTS följer frågan. PTS har fortsatt ansvar för
          övervakningen av att utbyggnadslagen följs.&nbsp;
          <a
            href="https://eur-lex.europa.eu/eli/reg/2024/1309/oj"
            title="Förordningen om gigabitinfrastruktur"
          >
            För mer information om förordningen om gigabitinfrastruktur.
          </a>
        </p>
        <br />
        <br />
        <br />
      </div>
    </>
  );
}
export default Page;
